export default "__VITE_ASSET__BoKPkxhR__"